<!--
account/account.vue
-->
<template>
    <div id="s-comboSelector">

        <b-row class="justify-content-center">
                <span class="btnContainer" v-if="selectStatus">
                    <b-button :disabled="disable" v-if="content.length > 0" :class="selectItemText == '' ? 'btnShow btnShowStateOff' : 'btnShow btnShowStateOn'" @click="$bvModal.show(name)">{{title}} {{selectItemText}}</b-button>
                </span>
                <span class="btnContainer" v-else>
                    <b-button :disabled="disable" v-if="content.length > 0" class="btnShow btnShowStateStd" @click="$bvModal.show(name)">{{title}} {{selectItemText}} </b-button>
                </span>
        </b-row>
    
            <b-modal :body-bg-variant="getTheme.light" :header-bg-variant="getTheme.dark" :header-text-variant="getTheme.light" :id="name" :title="title" hide-footer>
                
                <b-row class="addLicContainer">
                    <b-form-input class="txtLeft" id="search" name="search" type="text" :placeholder="$t('g_Recherche')" v-model="txtRecherche"></b-form-input>
                    <b-button type="button" class="btnLeft" @click="txtRecherche = ''">{{$t('g_Efface')}}</b-button>
                </b-row>

                <!--CONTENU-->
                <div class="scroll borderMain">
                    <b-list-group style="margin-top: 5px">
                            <b-list-group-item v-if="!noNone" class="cursorPoint btnRemove" @click="handleInput('0', '')"><span>{{$t('g_Aucun')}}</span></b-list-group-item>
                            <b-list-group-item :class="item[returnField] == selectedItems ? 'cursorPoint btnStylSelected' : 'cursorPoint btnStyle'" v-for="(item) in recherche" :key="item.index" @click="handleInput(item[returnField], item[showField], txtRecherche='')">
                               <span>{{item[showField]}}</span>
                            </b-list-group-item>
                    </b-list-group>

                </div>
            </b-modal>
        </div>
    
</template>

<script>
import {mapGetters} from 'vuex'


export default{
    name: 's-comboSelector',
    props: {
        selectStatus: Boolean, //Permet de mettre le contour du bouton en Vert / Rouge selon si la selection est obligatoire ou non
        name: String,
        title: String,
        content: null,
        showField: String,
        returnField: String,
        selectedItems: null,
        disable: Boolean,
        noNone: Boolean, //Si on eneleve le AUCUN
        baseZero: Boolean //Si la base est une base 0 ou une base 1 ou autre.... a TRUE c'est une base 1
    },
    data() {
        return {
            txtRecherche: '',
            selectItemText: '',
        }
    },
    methods: {
        handleInput(valeur, itemText) {
            this.selectItemText = itemText
            this.$emit('update:returnValue', valeur)
            this.$bvModal.hide(this.name)
        },
        getSelectedText(itemNumber){
            let row = this.content.find(item => item.id == itemNumber); 
            if(typeof row == 'undefined') return '---'
            return row[this.showField]
        }
    },
    computed: {
        ...mapGetters(['getTheme']),
        status() {
            return this.value
        },
        recherche() {
            const search = this.txtRecherche.toLowerCase().trim();
            if (!search) return this.content
            return this.content.filter(c => c[this.showField].toLowerCase().indexOf(search) > -1);
        },

    },
    watch: {
        selectedItems: function() {
            //console.log(this.baseZero)
            if (this.noNone)
            {
                console.log(this.getSelectedText(this.selectedItems))
                this.selectItemText = ' : ' + this.getSelectedText(this.selectedItems)//' : ' + this.getSelectedText(this.selectedItems)
            }
            else
                {
                if (this.baseZero)
                {
                    //console.log('1')
                    if (this.selectedItems < 0)
                    {this.selectItemText = ''}
                    else
                    {this.selectItemText = ' : ' + this.getSelectedText(this.selectedItems)}
                }
                else
                {
                    //console.log('2')
                    if (this.selectedItems <= 0)
                    {this.selectItemText = ''}
                    else
                    {this.selectItemText = ' : ' + this.getSelectedText(this.selectedItems)}
                }
            }
        }
    }    
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/components/comboSelector.scss'
</style>